<template>
  <header class="wrapper accent_dark">
    <img v-if="event.header_image_url !== null" :src="event.header_image_url" alt="background" class="background_img" />
    <div class="headerArea_inner flex_center sp_noflex bg">
      <Logo :default-hall="defaultHall" :can-show-logo="canShowLogo" />
      <Title :default-hall="defaultHall" />
      <LoginUser />
    </div>
  </header>
</template>

<script>
import Logo from "../modules/Logo"
import Title from "../modules/Title"
import LoginUser from "../modules/LoginUser"

export default {
  name: "Header",
  components: {
    Logo,
    Title,
    LoginUser
  },
  data() {
    return {
      canShowLogo: true
    }
  },
  created() {
    this.checkCanShowLogo()
  },
  computed: {
    defaultHall() {
      return this.$store.getters["hall/mainOrFirst"]
    },
    event() {
      return this.$store.getters["event/event"]
    }
  },
  methods: {
    checkCanShowLogo() {
      if (Number(this.event.id) === Number(this.$config.app.noneLogoEventId)) {
        this.canShowLogo = false
      }
    }
  }
}
</script>
